module.exports = __webpack_public_path__ + "img/61.fc65e926.jpg";